module.exports = __webpack_public_path__ + "@/assets/img/empty-state-coffee-cup.3ab848a0.svg";